import {Button} from '@wandb/weave/components';
import React from 'react';

type Props = {
  onClick: () => void;
};

export const CreateSweepButton: React.FC<Props> = ({onClick}) => {
  return (
    <Button
      icon="sweeps-broom"
      variant="secondary"
      twWrapperStyles={{display: 'inline'}}
      onClick={onClick}>
      New sweep
    </Button>
  );
};
